;(function () {
  'use strict'

  const angular = window.angular

  angular
    .module('appServices', ['lbServices'])

})()
